<template>
  <div class="search">
    <div class="container">
      <div class="row">
        <input
          class="w-100 p-3"
          type="text"
          placeholder="Resault for keyword"
          name="search"
          id="search"
          v-model="word"
          v-on:keyup.enter="navigates"
        />
      </div>
    </div>
    <div class="container">
      <div class="row">
        <h1 v-if="tags.length" class="w-100 search--text__header mt-5">
          Tags
        </h1>
        <span
          v-for="tag in tags"
          :key="tag._id"
          @click="navigateTga(tag._id)"
          style="margin: 7px 4px"
        >
          <span
            :style="
              `font-size: 1.1rem; cursor: pointer; display: initial;color: white;height:20px;background:${
                tag.color
              }`
            "
            class="badge"
            @click="navigateTga(tag._id)"
            >#{{ tag.name }}</span
          >
        </span>
      </div>
      <div v-if="categories.length" class="row">
        <h1 v-if="categories.length" class="w-100 search--text__header mt-5">
          Categories
        </h1>

        <swiper
          class="swiper"
          :options="{
            ...swiperOption,
            slidesPerView: categories.length >= 4 ? 4 : categories.length,
          }"
        >
          <swiper-slide v-for="cat in categoriesColorful" v-bind:key="cat._id">
            <div
              @click="navigateCat(cat)"
              style="cursor: pointer"
              class="w-100"
            >
              <div
                class="brands-classes"
                v-bind:style="{
                  backgroundImage:
                    'linear-gradient(to right,' +
                    cat.first +
                    ',' +
                    cat.second +
                    ' )',
                }"
              >
                <img
                  class="zoomIn"
                  style="padding: 1px"
                  width="70%"
                  v-bind:src="
                    'https://ardunic-images.s3.eu-central-1.amazonaws.com/' +
                      cat.image
                  "
                  alt
                />
              </div>
              <h3 style="cursor: pointer">{{ cat.name }}</h3>
            </div>
          </swiper-slide>
          <div
            v-if="categories.length >= 4"
            class="swiper-button-prev"
            slot="button-prev"
          ></div>
          <div
            v-if="categories.length >= 4"
            class="swiper-button-next"
            slot="button-next"
          ></div>
        </swiper>
      </div>
      <div class="row">
        <h1 v-if="products.length" class="w-100 search--text__header mt-5">
          Products
        </h1>
        <div class="cards-display-grid mt-4">
          <products-card
            v-for="(product, index) in products"
            :key="`${index}--INDEX__PRODUCT`"
            :product="product"
            class="card-new animatee"
          />
        </div>
        <nav class="mt-2" aria-label="Page navigation example">
          <ul class="pagination justify-content-end">
            <li class="page-item">
              <a style="cursor: pointer" class="page-link" @click="previous"
                >Previous</a
              >
            </li>
            <li class="page-item">
              <a style="cursor: pointer" class="page-link" @click="next"
                >Next</a
              >
            </li>
          </ul>
        </nav>
      </div>
    </div>
  </div>
</template>

<script>
import router from "../router";
import axios from "axios";

import ProductsCard from "../components/Utilities/Cards/Products.vue";

import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
export default {
  name: "ProductSearch",
  components: {
    ProductsCard,
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      products: [],
      word: "search here",
      page: 1,
      size: 8,
      categories: [],
      tagss: [],
      colors: [
        { first: "#ff0400", second: "#ffcf69" },
        { first: "#c7f1ff", second: "#00d6ff" },
        { first: "#02b718", second: "#00d6ff" },
        { first: "#f16522", second: "#ffcf69" },
        { first: "#ff2cc6", second: "#ffcf69" },
      ],
      swiperOption: {
        slidesPerView: 4,
        spaceBetween: 20,
        loop: true,
        pagination: {
          el: ".swiper-pagination",
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
    };
  },
  watch: {
    "$route.params.word": function() {
      this.products = [];
      this.tagss = [];
      this.categories = [];
      this.page = 1;
      this.search();
    },
    "$route.params.page": function() {
      this.search();
    },
    page: function() {
      this.navigates();
    },
  },
  created() {
    axios
      .get(
        `https://api.ardunic.com/v1/search?name=${this.$route.params.word}&p=${
          this.$route.params.page
        }&s=16`
      )
      .then((res) => {
        this.products = res.data.data.products || [];
        this.tagss = res.data.data.tags || [];
        this.categories = res.data.data.categories || [];
        this.word = this.$route.params.word;
        this.page = parseInt(this.$route.params.page);
      });
  },

  methods: {
    navigates() {
      router.push({ path: `/search/${this.word}/${this.page}` });
    },
    navigateCat(category) {
      if (category.categories.length === 0) {
        router.push({
          path: `/sub/${category.name}/${category._id}`,
        });
      } else
        router.push({
          path: `/sub/${category.name}/${category.name}/${
            category._id
          }/products`,
        });
      // console.log(slug);
    },
    navigateTga(id) {
      router.push({ path: `/tag/${id}` });
      // console.log(slug);
    },
    search() {
      axios
        .get(
          `https://api.ardunic.com/v1/search?name=${
            this.$route.params.word
          }&p=${this.page}&s=16`
        )
        .then((res) => {
          this.products = res.data.data.products || [];
          this.tagss = [...this.tagss, ...(res.data.data.tags || [])];
          this.categories = [
            ...this.categories,
            ...(res.data.data.categories || []),
          ];
          this.word = this.$route.params.word;
          this.page = parseInt(this.$route.params.page);
        });
    },
    next() {
      this.page += 1;
    },
    previous() {
      this.page != 1 ? this.page-- : (this.page = 1);
    },
  },

  computed: {
    categoriesColorful() {
      return this.categories.map((cat) => {
        const randomGradiant = this.colors[
          Math.floor(Math.random() * this.colors.length)
        ];
        const colors = {
          first: randomGradiant.first,
          second: randomGradiant.second,
        };
        Object.assign(cat, colors);
        return cat;
      });
    },
    tags() {
      return this.tagss.map((tag) => {
        const colors = [
          "linear-gradient(90deg, #00E5FF 0%, #02B718 100%);",
          "linear-gradient(90deg, #40C012 0%, #AAF064 100%);",
          "linear-gradient(90deg, #EB3D3D 0%, #FC965C 100%);",
          "linear-gradient(90deg, #3DEBAC 0%, #5CFCF2 100%);",
          "linear-gradient(90deg, #DDB54D 0%, #E5F064 100%);",
          "linear-gradient(90deg, #0047FF 0%, #31CAFB 100%);",
        ];

        return {
          ...tag,
          color: colors[Math.floor(Math.random() * (5 - 0) + 0)],
        };
      });
    },
  },
};
</script>

<style scoped>
/* .swiper-slide {
  width: 100% !important;
} */
.brands-classes {
  width: 255px;
  height: 180px;
  padding: 15px;
  border: none;
  border-radius: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.search--text__header {
  font-style: normal;
  font-weight: 600;
  font-size: 36px;
  line-height: 44px;
}
.search {
  margin-top: 90px;
}
.cards-display-grid {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.btn {
  border-radius: 15px;
}

@media (max-width: 767px) {
  #search-cards-row {
    padding: 0px;
  }
  #list-col {
    max-width: 100%;
  }
}

.filters {
  list-style: none;
  text-align: center;
}
.filters .filter-iteam {
  /* background: #c1c2c5; */
  margin: 5px;
  width: 200px;
  border-radius: 15px;
  font-size: 1.2rem;
  color: white;
}
.grey {
  background: #c1c2c5;
}

.botn {
  font-size: 20px;
  border-radius: 20px;
  outline: none;
  width: 400px;
  height: 60px;
  font-weight: bold;
}
.botn-blue {
  color: white;
  text-align: center;
  background: linear-gradient(to right, #f6893a, #fdbd5d);
}

.org {
  background: linear-gradient(right, #ff3fbb, #ff8891);
}

.blue {
  background: linear-gradient(to right, #05cefc, #5659ce);
}
.view-more {
  position: relative;
  top: -30px;
}

.filterBy {
  border-radius: 15px;
  border: 1px solid #c1c2c5;
}

#search {
  border-radius: 15px;
  border: 1px solid #c1c2c5;
  font-size: 30px;
  color: black;
}
/* .filters {
  text-align: center;
  margin: 0 auto;
} */

.card-new {
  margin-bottom: 13px;
  border-radius: 10px;
  padding: 12px 12px;
  overflow: hidden;
  box-shadow: none !important;
  -moz-box-shadow: none !important;
  -webkit-box-shadow: none !important;
}

.img-new {
  width: 100%;
}

.img-div {
  position: relative;
  text-align: center;
  margin-bottom: 10px;
  line-height: 0;
  width: 100%;
  overflow: hidden;
}

.card-img-new {
  max-height: 100%;
  max-width: 100%;
}

.title-new {
  height: auto;
  line-height: 18px;
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  color: black;
  font-size: 14px;
  font-weight: bold;
}

.price-new {
  overflow: hidden;
  display: block;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.price-span {
  margin-right: 4px;
  font-size: 16px;
  font-weight: 700;
  height: 18px;
  line-height: 18px;
  color: #333;
  vertical-align: middle;
  font-weight: 700;
}
</style>
